import { useAccount, useConnect, useDisconnect, useBalance } from 'wagmi';

export function useWallet() {
  const { address, isConnected, isConnecting, chain } = useAccount();
  const { connect, connectors, error: connectError } = useConnect();
  const { disconnect } = useDisconnect();
  const { data: balance } = useBalance({
    address,
  });

  const connectWallet = async (connectorIndex = 0) => {
    const connector = connectors[connectorIndex];
    if (connector) {
      connect({ connector });
    }
  };

  return {
    address,
    isConnected,
    isConnecting,
    chain,
    balance,
    connect: connectWallet,
    disconnect,
    connectors,
    connectError,
  };
}
